import { getJsonHomologation } from "../services/serviceAPI";
const { randomBytes } = require('crypto');
/** Define la homologacion del campo extra 5 de request checkoout epayco*/
export const fillExtra4 = async (channel) => {
  let homologation = "";
  if (channel == null) {
    return "Web Pública";
  }
  channel = channel.toLowerCase();
  const response = await getJsonHomologation();
  const listResult = response.data;
  const extraFound = await findChannel(listResult, channel);
  const containEcare = channel.includes("ecare");
  const containSms = channel.includes("sms");
  const containApp = channel.includes("app");
  const validator = `${extraFound}-${containEcare}-${containSms}-${containApp}`;
  switch (validator) {
    case "true-false-false-false":
      homologation = listResult.find((x) => x.extra_2 === channel).extra_5;
      break;
    case "false-true-false-false":
      homologation = "Webprivada";
      break;
    case "false-false-true-false":
      homologation = "sms";
      break;
    case "false-false-false-true":
      homologation = "app";
      break;
    default:
      homologation = "Webpublica";
      break;
  }

  return homologation;
};

/** Encuentra la homologacion del canal en el json*/
const findChannel = async (obj, chn) => {
  let found = false;
  for (const value of obj) {
    if (value.extra_2 === chn) {
      found = true;
    }
  }
  return found;
};

export const formatPrice = (price) => {
  return price.toLocaleString("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  });
};

export const extractNumbers = (inputString) => {
  return inputString.replace(/[^0-9.,]/g, "");
};

export const cargarScriptePayco = () => {
  var head = document.getElementsByTagName('head')[0]
  var script1 = document.createElement('script');
  script1.setAttribute('src', 'https://checkout.epayco.co/checkout.js');
  script1.setAttribute('type', 'text/javascript');
  head.appendChild(script1);
};

export const getIsHoliday = (hd, fecha) => {
  if (
    hd.isHoliday(fecha.toDate())?.length > 0 &&
    fecha.day() !== 6 &&
    fecha.day() !== 0
  ) {
    return hd.isHoliday(fecha.toDate());
  }
  return null;
};

export const createStep = (number, label, state = "", line = true, complete = false) => {
  return { number, label, state, line, complete };
}

export const generateLegacyID = () => {
  const dateNow = new Date().toLocaleString("en-US", { timeZone: "America/Bogota" });
  const randomBytesBuffer = randomBytes(4); // Genera 4 bytes aleatorios
  const random_number = parseInt(randomBytesBuffer.toString('hex'), 16) % (999999 - 100000 + 1) + 100000;
  const orderId = new Date(dateNow).toISOString().replace(/[^0-9]/g, "").slice(0, 14) + random_number;
  return orderId;
}

export const getDocValueById = (id) => {
  const mobileDocuments = [
    {
      key: "1",
      value: "CC",
      label: "CC",
    },
    {
      key: "2",
      value: "CE",
      label: "CE",
    },
    {
      key: "3",
      value: "PS",
      label: "PS",
    },
  ];
  const document = mobileDocuments.find(doc => doc.key === id);
  return document ? document.value : "";
}